import { defineStore } from 'pinia'

let nextId = 1

export type Notification = {
  type: 'error' | 'info'
  message: string
  id: number
}

export const useNotificationStore = defineStore('notification', {
  state: () => ({
    notifications: [] as Notification[],
  }),
  actions: {
    add(notification: Omit<Notification, 'id'>) {
      // `this` is the store instance
      this.notifications.push({
        ...notification,
        id: nextId++,
      })
    },

    remove(notificationToRemove: Notification) {
      this.notifications = this.notifications.filter((n) => n.id !== notificationToRemove.id)
    },
  },
})
